/* eslint-disable no-return-await */
/* eslint-disable no-useless-constructor */
import axios from 'axios';
import qs from 'qs';

import { BaseService } from 'core/services/base.abstract.service';
import { CurrentUserModel } from 'core/models/currentUser.model';
import { StatusCodes } from 'http-status-codes';

export class CurrentUserService extends BaseService {
  constructor(env, token) {
    super(env, token);
  }
  getCurrentUser = async () => {
    return await axios
      .get(`${this.apiUrl}/api/users/current`, {
        headers: this.authorization,
      })
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === StatusCodes.OK) {
          return new CurrentUserModel(bo);
        }
        throw new Error(bo.error);
      });
  };

  checkUserSessionIsStillValid = async () => {
    const token = sessionStorage.getItem('token');
    const data = { token };
    const headers = { 'content-type': 'application/x-www-form-urlencoded' };
    const url = `${this.orchardUrl}/oauth2/token_info`;
    let userSessionStillValidResponse;

    try {
      userSessionStillValidResponse = await axios({
        method: 'POST',
        headers,
        data: qs.stringify(data),
        url,
      });

      const userSessionStillValidData = userSessionStillValidResponse?.data;

      if (userSessionStillValidResponse.status !== StatusCodes.OK) {
        throw new Error(userSessionStillValidData.error);
      }

      return userSessionStillValidData.active;
    } catch (e) {
      throw new Error(e.message);
    }
  };
}
